import React from "react";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const WaterStations = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img
            src="assets/img/Banner/portal-banner6.jpg"
            className="img-fluid"
            alt="alt"
          />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="p-2">
            <h3 className="fontSizeClass"> {t("Water Station")} </h3>
          </div>
          <div id="accordion">
            <div className="card">
              <div className="card-header" id="heading5">
                <button
                  class="btn btn-link fontSizeClass "
                  data-toggle="collapse"
                  data-target="#collapse5"
                  aria-expanded="true"
                  aria-controls="collapse5"
                >
                  {t("Existing Water Treatment Plant :")} :
                </button>
              </div>
              <div id="collapse5" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <ol type="1" className="kmc-function-list">
                    {[
                      "Indira Gandhi Water Treatment Plant - Palta",
                      "Garden Reach Treatment Plant",
                      "Jai Hind Jal Prakalpa - Dhapa",
                      "Jorabagan Water Treatment Plant",
                      "Watgunge Water Treatment Plant",
                    ].map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading2">
                <button
                  class="btn btn-link fontSizeClass "
                  data-toggle="collapse"
                  data-target="#collapse2"
                  aria-expanded="true"
                  aria-controls="collapse2"
                >
                  {t("Water Treatment Plant (Under Construction) :")} :
                </button>
              </div>
              <div id="collapse2" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <ol type="1" className="kmc-function-list">
                    {[
                      "Garden Reach Water Works - 25 MGD Capacity.",
                      "Indira Gandhi Water Treatment Plant - Palta - 20 MGD",
                    ].map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading3">
                <button
                  class="btn btn-link fontSizeClass "
                  data-toggle="collapse"
                  data-target="#collapse3"
                  aria-expanded="true"
                  aria-controls="collapse3"
                >
                  {t("Existing Booster Pumping Station with Reservoirs :")} :
                </button>
              </div>
              <div id="collapse3" className="collapse" data-parent="#accordion">
                <div className="card-body m-3 fontSizeClass">
                  <p className="fontSizeClass">
                    {t(
                      "Tallah pumping station,Raja Subodh Mullick Square, Auckland Square, Behala, Md. Ali Park, Garfa, Park Circus, Ranikuthi, Kalighat, Bansdroni, Kasba, Bagmari, New Park, Daspara, Siriti, Anandapur, Gandhi Maidan, Telipara, Baishnabghata Patuli, Chetla, G J Khan Road, Khejurtala, Shanti Pally, Hatisur, Phool Bagan, Narkel Bagan, Lalgata, Mukundapur,Harish Park,Convent Park,Prafulla Park,Chaulpatty Road,Sen Pally,Parnashree Vivekananda Kanan,Layalka,Behala Chourastha,Bansdroni UGR Extension,Cocola Bagan,Agrashi Math,Hindustan Park,Nagendra Uddan,Airport Road,Poddar Nagar,Jodhpur Park Head Work,Golf Green Head Work,Ram Thakur Asram,Oposite Navina Badamtala,Near Burial Ground,Chandni Ghosh Road,Naktala,Netaji Nagar,Layelka Head Work,86 Pally Math,Rajani Mukherjee Rd,Parnasree Quarter."
                    )}
                    .
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="heading4">
                <button
                  class="btn btn-link fontSizeClass "
                  data-toggle="collapse"
                  data-target="#collapse4"
                  aria-expanded="true"
                  aria-controls="collapse4"
                >
                  {t("Booster Pumping Station (Under Construction) :")} :
                </button>
              </div>
              <div id="collapse4" className="collapse" data-parent="#accordion">
                {/* <div className="card-body m-3 fontSizeClass">
                  <p className="fontSizeClass">
                    {" "}
                    {t(
                      "Anandapur Extension,Dhapa Water Work,C.N.Roy Road,Hatgachia Panchannagram,Panchasayar,Kayasthyapara, Achena Park,C.R.Colony,Subhash Pally,Garden Reach Water Work,Shakuntala Park,Bangur Park,Babu Bagan,Sachin Sengupta Park,Taramani Ghat,Deshpryia Park,Townshed(Golmath),4 No Bandh ,Park Near AMRI,Swamiji Sarak,Green Park,Jaysree Park,G.S.Bose Road."
                    )}
                    .
                  </p>
                </div> */}
                <div className="card-body m-3 fontSizeClass">
                  <DownloadFileByFileStoreId
                    fileStoreId={"4a8e7847-1d6e-4290-ae7d-9d56c2a93bb8"}
                    label={
                      "Water Supply Booster Pumping Station - JHJP IGWTP GRWW Command zone as on June 2025"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WaterStations;
